<template>
  <div v-show="this.show" class="toast" :class="{ leave: this.cls }">
    {{ msg }}
  </div>
</template>

<script>
export default {
  props: {
    msg: String,
    cls: Boolean,
    show: Boolean
  }
}
</script>
<style scoped>
  .toast {
    white-space: nowrap;
    color: #fff;
    padding: .5em 1em;
    border-radius: 1.2em;
    font-size: .9em;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    animation: ani-alert 0.2s 0.1s both;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
  }
  .toast.leave {
    animation: ani-out 0.2s 0.1s both;
  }
  @keyframes ani-alert {
    0%{ transform:translate(-50%,0%); opacity: 0;}
    100%{ transform:translate(-50%,-50%); opacity: 1;}
  }
  @keyframes ani-out {
    0% { transform: translate(-50%, -50%); opacity: 1;}
    100% { transform: translate(-50%, 0%); opacity: 0;}
  }
</style>